import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BreadcrumbService } from 'angular-crumbs';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TitleAndCrumbServiceService {

  constructor(private titleService: Title, private breadcrumbService: BreadcrumbService) { }
  
  changeTitleAndCrumb(route:ActivatedRoute, title: string) {
    this.titleService.setTitle(title);
    this.breadcrumbService.changeBreadcrumb(route.snapshot, title);
  }
}
